<div class="html-content" [innerHTML]="text()"></div>
